// src/componentes/RutaPrivada.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const RutaPrivada = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/iniciar-sesion" replace />;
  }

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decodedToken.exp < currentTime) {
      // Token expirado
      localStorage.removeItem('token');
      return <Navigate to="/iniciar-sesion" replace />;
    }
  } catch (error) {
    // Error al decodificar el token
    localStorage.removeItem('token');
    return <Navigate to="/iniciar-sesion" replace />;
  }

  return <Outlet />;
};

export default RutaPrivada;
